export const GENDER_ENUMS = {
  MALE: "Male",
  FEMALE: "Female",
};

export const GENDER_DROPDOWN_OPTIONS = Object.values(GENDER_ENUMS).map(
  (value, idx) => ({
    id: `${value}-${idx}`,
    label: value,
    value,
    selectedLabel: value,
  }),
);
